import { apiCall } from '../apiHelpers';

// Books CRUD functions
export const getBooks = async (clubId, userId = null) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  if (userId) {
    params.append('userId', userId);
  }
  const result = await apiCall(`/v1/books?${params}`);
  return result.books || result;
};

export const getBook = async (clubId, bookId, userId = null) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  if (userId) {
    params.append('userId', userId);
  }
  return apiCall(`/v1/books/${bookId}?${params}`);
};

export const addBook = async (clubId, book, userId) => {
  const params = new URLSearchParams({ clubId: clubId.toString(), userId });
  const result = await apiCall(`/v1/books?${params}`, {
    method: 'POST',
    body: JSON.stringify(book),
  });
  return result;
};

export const updateBook = async (clubId, bookId, updates) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  const result = await apiCall(`/v1/books/${bookId}?${params}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
  return result;
};

export const deleteBook = async (clubId, bookId) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  await apiCall(`/v1/books/${bookId}?${params}`, {
    method: 'DELETE',
    body: JSON.stringify({ clubId }) // Sometimes DELETE might need body or query, usually query is enough
  });
};

// Books pagination and filtering
export const getBooksPage = async (clubId, pageNumber = 1, pageSize = 10, orderByField = 'created_at', orderDirection = 'desc', userId = null, readStatus = null, search = '', uploadedBy = null, listScope = null, likedByMe = false, bookmarkedOnly = false) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    page: pageNumber.toString(),
    pageSize: pageSize.toString(),
    orderBy: orderByField,
    orderDirection,
  });
  if (userId) {
    params.append('userId', userId);
  }
  if (readStatus) {
    params.append('readStatus', readStatus);
  }
  if (search) {
    params.append('search', search);
  }
  if (uploadedBy && uploadedBy !== 'all') {
    params.append('uploadedBy', uploadedBy);
  }
  if (listScope) {
    params.append('listScope', listScope);
  }
  if (likedByMe) {
    params.append('likedByMe', 'true');
  }
  if (bookmarkedOnly) {
    params.append('bookmarkedOnly', 'true');
  }
  return apiCall(`/v1/books?${params}`);
};

export const getBooksPageFiltered = async (clubId, theme, pageNumber = 1, pageSize = 10, orderByField = 'created_at', orderDirection = 'desc', userId = null, readStatus = null, search = '', uploadedBy = null, listScope = null, likedByMe = false, bookmarkedOnly = false) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    theme,
    page: pageNumber.toString(),
    pageSize: pageSize.toString(),
    orderBy: orderByField,
    orderDirection,
  });
  if (userId) {
    params.append('userId', userId);
  }
  if (readStatus) {
    params.append('readStatus', readStatus);
  }
  if (search) {
    params.append('search', search);
  }
  if (uploadedBy && uploadedBy !== 'all') {
    params.append('uploadedBy', uploadedBy);
  }
  if (listScope) {
    params.append('listScope', listScope);
  }
  if (likedByMe) {
    params.append('likedByMe', 'true');
  }
  if (bookmarkedOnly) {
    params.append('bookmarkedOnly', 'true');
  }
  return apiCall(`/v1/books/filtered?${params}`);
};

export const getAllDiscussedBooks = async (clubId, userId = null, listScope = null) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  if (userId) {
    params.append('userId', userId);
  }
  if (listScope) {
    params.append('listScope', listScope);
  }
  return apiCall(`/v1/books/discussed?${params}`);
};

// Legacy functions for backward compatibility
export const getBookMetadata = async (clubId) => {
  // For PostgreSQL, we compute this on-demand
  const result = await getBooksPage(clubId, 1, 1);
  return { totalCount: result.totalCount, lastUpdated: new Date() };
};

export const updateBookMetadata = async (incrementBy = 1) => {
  // This is a no-op for PostgreSQL since we compute metadata on-demand
};

export const initializeBookMetadata = async (clubId) => {
  const result = await getBooksPage(clubId, 1, 1);
  return result.totalCount;
};

// Books progress functions
export const getBooksProgress = async (clubId, page = 1, pageSize = 10, bookId = null) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    page: page.toString(),
    pageSize: pageSize.toString(),
  });
  if (bookId) {
    params.append('bookId', bookId.toString());
  }
  return apiCall(`/v1/books/progress?${params}`);
};

export const getTopReaders = async (clubId, limit = 10) => {
  const params = new URLSearchParams({ 
    clubId: clubId.toString(),
    limit: limit.toString() 
  });
  return apiCall(`/v1/books/top-readers?${params}`);
};

export const likeBook = async (clubId, bookId, userId) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    userId,
  });
  return apiCall(`/v1/books/${bookId}/like?${params}`, {
    method: 'POST',
  });
};

export const unlikeBook = async (clubId, bookId, userId) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    userId,
  });
  return apiCall(`/v1/books/${bookId}/like?${params}`, {
    method: 'DELETE',
  });
};
